export default __webpack_public_path__ + "static/media/saleperson-icon.642c5b46.svg";